/**
 * UTM Parameter Tracking Utility
 * Captures and preserves UTM parameters from the visitor's session
 */

const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
const STORAGE_KEY = 'elevate_utm_params';

/**
 * Capture UTM parameters from URL and store in sessionStorage
 * Call this on app initialization
 */
export const captureUTMParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams = {};
  let hasUtm = false;
  
  UTM_PARAMS.forEach(param => {
    const value = urlParams.get(param);
    if (value) {
      utmParams[param] = value;
      hasUtm = true;
    }
  });
  
  // Only update if we have new UTM params (don't overwrite existing)
  if (hasUtm) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utmParams));
  }
};

/**
 * Get stored UTM parameters
 * @returns {Object|null} UTM parameters object or null if none stored
 */
export const getUTMParams = () => {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch (e) {
    console.warn('Failed to retrieve UTM params:', e);
    return null;
  }
};

/**
 * Get UTM parameters with current page info
 * @param {string} sourcePage - The current page path
 * @returns {Object} UTM params with source page info
 */
export const getUTMParamsWithSource = (sourcePage) => {
  const utm = getUTMParams() || {};
  return {
    ...utm,
    source_page: sourcePage || window.location.pathname
  };
};

/**
 * Clear stored UTM parameters
 */
export const clearUTMParams = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};

export default {
  captureUTMParams,
  getUTMParams,
  getUTMParamsWithSource,
  clearUTMParams
};
